import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IPreventiveExaminationReduced } from '@/_types'

/**
 * Fetches reduced preventive examination data for checkout or program selection.
 *
 * @param id - Preventive examination id.
 */
export const fetchPreventiveExamination = async (
	id: number
): Promise<ApiResponse<IPreventiveExaminationReduced>> => {
	return axios
		.get<
			ApiResponse<IPreventiveExaminationReduced>
		>(`v1/web/preventiveExamination/preventiveExaminations/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchPreventiveExamination}; disabled when `id <= 0`.
 *
 * @param id - Preventive examination id.
 */
export const useGetPreventiveExamination = (id: number) => {
	return useQuery<ApiResponse<IPreventiveExaminationReduced>>({
		queryKey: ['preventive-examination', id],
		queryFn: () => fetchPreventiveExamination(id),
		enabled: id > 0,
		select: data => data
	})
}
